<template>
    <div class="content mt-3" v-if="enrollment.course.show_titles">
        <img class="pl-5 ml-2" v-if="enrollment.course.logo" :src="enrollment.course.logo" style="height: 70px;"/>

        <div class="ml-4 pl-4 mb-6 mt-5">
            <div class="has-text-grey-dark">
                <strong class="has-text-grey-dark">{{outline.section.title}}</strong> -
                {{outline.counts.ofSection}} of {{outline.counts.totalSection}}
                <span v-if="component.type === 'CHECKPOINT'" class="pl-4"><i class="far fa-location-check mr-2"></i>Checkpoint</span>
                <span v-if="component.type === 'QUIZ'" class="pl-4"><i class="far fa-clipboard-list-check mr-2"></i>Quiz</span>
            </div>
            <h2 class="mt-2">{{component.title}}</h2>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LessonHeader",
        props: ['enrollment', 'component', 'outline']
    };
</script>

<style scoped>

</style>
